module.exports = __webpack_public_path__ + "img/13-1.d7571898.png";